import { momentES } from "../utils/handler_dates";
import { fetchGET, fetchPUT } from "../utils/handler_http";
import { encoURI } from "../utils/handler_validations";

/**
 * Obtener la data de un pasajero de la lista
 */
export const getPassengerTemplate = () => ({
  id: 0,
  fullName: "",
  profileImg: "",
  tel: "",
});

export const getListPassengers = async (filterValue = "", jwt = "") => {
  const paramsQuery = {
    filterValue: encoURI(filterValue),
    date: encoURI(momentES().utc().format()),
  };
  const response = await fetchGET(
    process.env.REACT_APP_PASSENGERS_LIST_ENDPOINT,
    paramsQuery,
    { Authorization: jwt }
  );
  return response;
};

export const toggleUserTester = async (userId = 0, isTester = 0, jwt = "") => {
  const paramsBody = {
    userId: userId,
    isTester: typeof isTester === "boolean" ? (isTester ? 1 : 0) : isTester,
  };
  const response = await fetchPUT(
    process.env.REACT_APP_USER_TESTER_TOGGLE_ENDPOINT,
    paramsBody,
    { Authorization: jwt }
  );
  return response;
};

/**
 * Obtener la lista de usuarios testers registrados
 */
export const getTestersList = async (jwt = "") => {
  const response = await fetchGET(
    process.env.REACT_APP_TESTERS_LIST_ENDPOINT,
    {},
    { Authorization: jwt }
  );
  return response;
};
